import React from 'react';
import { useSelector } from 'react-redux';
import { Box, List, ListItem, ListItemText } from '@mui/material';
import { selectFilteredTaxDocuments, selectSelectedTaxYear } from '../../selectors/tax.selector';
import {
    themeVars,
    Text,
    Stack,
    ExclamationCircleIcon,
    Button,
    ArrowDownToBracketIcon
} from '@eds-web/react';
import { useTranslation } from 'react-i18next';
import { useDownloadTaxProfile } from '../../hooks/useDownloadTaxProfile';

export const TaxDocumentDownloadList: React.FC = () => {
    const selectedYears = useSelector(selectSelectedTaxYear);
    const filteredDocuments = useSelector(selectFilteredTaxDocuments);
    const { t } = useTranslation();
    const { loadingStates, downloadTaxProfile } = useDownloadTaxProfile();

    const handleDownloadClick = async (documentId: string, fileName: string) => {
        await downloadTaxProfile(documentId, fileName);
    };

    if (!selectedYears) {
        return null;
    }

    if (filteredDocuments.length === 0) {
        return (
            <Stack
                justify={'center'}
                align={'center'}
                style={{
                    backgroundColor: themeVars.color.background.elevated.low,
                    height: 250
                }}
            >
                <Text
                    variant={'paragraphMD'}
                    style={{ color: themeVars.color.transparent.light['100'] }}
                >
                    <ExclamationCircleIcon style={{ marginRight: 8 }} color={'secondary'} />
                </Text>
                <Text
                    variant={'paragraphMD'}
                    style={{ color: themeVars.color.transparent.light['065'] }}
                >
                    {t('epic.esport.profile.tax.form.notFound')}
                </Text>
            </Stack>
        );
    }

    return (
        <Stack style={{ backgroundColor: themeVars.color.background.elevated.low }}>
            <List>
                {filteredDocuments.map((document) => (
                    <ListItem
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: 64
                        }}
                        key={document.documentId}
                        divider
                        secondaryAction={
                            <Button
                                icon={<ArrowDownToBracketIcon />}
                                onClick={() => {
                                    handleDownloadClick(
                                        document.documentId,
                                        document.originalFieldName
                                    );
                                }}
                                loading={loadingStates[document.documentId] || false}
                                loadingLabel={t('epic.common.loading')}
                            >
                                {t('epic.esport.profile.tax.form.btn.download')}
                            </Button>
                        }
                    >
                        <ListItemText
                            secondary={
                                <Box>
                                    <Text variant={'paragraphMD'}>
                                        {t('epic.esport.profile.tax.form.name.v2', {
                                            fileName: document.originalFieldName
                                        })}
                                    </Text>
                                </Box>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </Stack>
    );
};
